/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmSpisovyUzelProPredavani extends GContentBase<SeznamAdmSpisovyUzelProPredavaniObj> {
        private seznamObj: SeznamAdmSpisovyUzelProPredavaniObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmSpisovyUzelProPredavaniObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmSpisovyUzelProPredavani",
                contentCaption: "jres:33000913", //RC 33000913 : Spisové uzly pro předávání
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{ixs_su_txt} - {nazev_su_pre}"
                },
                gridSettings: {
                    columnOrder: this.seznamObj.getColumnOrder()
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamAdmSpisovyUzelProPredavaniObj extends GAdmSeznamBase {
        ixs_su: string;

        getColumnOrder(): string {
            let columnOrder = "";
            if (this.ixs_su)
                columnOrder += "ixs_su_pre_txt,";
            columnOrder += "dat_zmena,zmenu_prov_txt";
            return columnOrder;
        }

        create() {

        }

        openDetail(data: any, isNew: boolean) {
            const cntInitializer = ["Gordic.Adm.WebControls.DetailAdmSpisovyUzelProPredavani", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid),
                openDialog: this.tabOpen
            }]
            const inputParams = {
                ID: "DetailAdmSpisovyUzelProPredavani",
                newRecord: isNew,
                ixs_su: isNew == true ? ((this.ixs_su) ? this.ixs_su : null) : data.ixs_su,
                ixs_su_pre: isNew == true ? null : data.ixs_su_pre
            }
            this.openDialogOrModalWindow(cntInitializer, inputParams);
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null;
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actAddToComparison*"]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar(["actOpenDetail*"])
        }

        createFilterForm() {
            this.filterForm.addRow("jres:29930955").addField("gselectbox", Gordic.Prefabs.Select.ginspod(), {
                name: "ixs_su",
                model: "model.ixs_su=value.ixs_su",
                dropdown: true,
                disabled: (this.ixs_su) ? true : false
            })
        }

        userhardDefaultFilter(hardFilter: any): any {
            if (this.ixs_su)
                hardFilter["ixs_su"] = this.ixs_su
            return hardFilter;
        }

        collectData(data: any) {
            if (this.ixs_su)
                data["ixs_su"] = this.ixs_su;
        }

        applydata(filterData: any) {
            this.cnt.isl.AdmSpisovyUzelProPredavani.list({ filters: filterData }).getView().done((data) => {
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {

        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: `${data.ixs_su}#${data.ixs_su_pre}#`,
                nazev: `${data.ixs_su_txt} - ${data.ixs_su_pre_txt}`
            }
        }
    }
}